import { Component } from '@angular/core';

@Component({
  templateUrl: './privacypolicy.html',
  standalone: false
})
export class PrivacyPolicyComponent { }
